export const getPackageRoutes = () => {
  const BASE_ROUTE = `/packages`;

  const ROUTE_SEGMENTS = {
    SEARCH: "search",
    HOTELS: {
      AVAILABILITY: "hotels/availability",
      SHOP: "hotels/shop",
      ROOM_SELECTION: "room-selection",
    },
    FLIGHTS: {
      DEPARTURE: "flights/departure",
      RETURN: "flights/return",
    },
    CARS: {
      AVAILABILITY: "cars/availability",
      SHOP: "cars/shop",
    },
    REVIEW: "review",
    CHECKOUT: "checkout",
  };

  const FULL_ROUTES = {
    SEARCH: `${BASE_ROUTE}/${ROUTE_SEGMENTS.SEARCH}`,
    HOTELS: {
      AVAILABILITY: `${BASE_ROUTE}/${ROUTE_SEGMENTS.HOTELS.AVAILABILITY}`,
      SHOP: `${BASE_ROUTE}/${ROUTE_SEGMENTS.HOTELS.SHOP}`,
      ROOM_SELECTION: `${BASE_ROUTE}/${ROUTE_SEGMENTS.HOTELS.SHOP}/:lodgingName?/:lodgingId/${ROUTE_SEGMENTS.HOTELS.ROOM_SELECTION}`,
    },
    FLIGHTS: {
      DEPARTURE: `${BASE_ROUTE}/${ROUTE_SEGMENTS.FLIGHTS.DEPARTURE}`,
      RETURN: `${BASE_ROUTE}/${ROUTE_SEGMENTS.FLIGHTS.RETURN}`,
    },
    CARS: {
      AVAILABILITY: `${BASE_ROUTE}/${ROUTE_SEGMENTS.CARS.AVAILABILITY}`,
      SHOP: `${BASE_ROUTE}/${ROUTE_SEGMENTS.CARS.SHOP}`,
    },
    REVIEW: `${BASE_ROUTE}/${ROUTE_SEGMENTS.REVIEW}`,
    CHECKOUT: `${BASE_ROUTE}/${ROUTE_SEGMENTS.CHECKOUT}`,
  };

  return {
    BASE_ROUTE,
    ROUTE_SEGMENTS,
    FULL_ROUTES,
  };
};
